import React, { Component } from "react";
import { Link } from "react-router-dom";
import { matchPath } from "react-router";
import CPF from "gerador-validador-cpf";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as ParticipantsActions } from "store/ducks/participants";

import { Validate } from "common";
import { Page, Panel, Button, Loading } from "components";
import { Form } from "pages/Admin/Participants/components";

class Edit extends Component {
  state = {
    data: {
      name: "",
      email: "",
      cpf: "",
      locale: { value: "pt-BR", label: "Português" }
    },
    errors: {}
  };

  componentDidMount() {
    this.props.getParticipantRequest(this.handleGetID());
  }

  componentDidUpdate(oldProps) {
    const { data } = this.state;
    const { participant } = this.props;

    if (oldProps.participant.loading && !participant.loading) {
      this.setState({
        data: {
          ...data,
          name: participant.data.attributes.name,
          email: participant.data.attributes.email,
          cpf: participant.data.attributes.cpf,
          locale:
            participant.data.attributes.locale === "en"
              ? { value: "en", label: "Inglês" }
              : participant.data.attributes.locale === "pt-BR" 
              ? { value: "pt-BR", label: "Português" }
              : { value: "es", label: "Espanhol" }
        }
      });
    }
  }

  handleGetID = () => {
    const match = matchPath(this.props.location.pathname, {
      path: "/admin/participants/:id/edit"
    });
    return match.params.id;
  };

  handleChange = data => {
    this.handleValidate();
    this.setState({ data });
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      name: {
        required: true
      },

      email: {
        required: true,
        email: true
      },

      locale: {
        required: true
      }
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSubmit = e => {
    e.preventDefault();

    if (!this.handleValidate()) return null;

    const { data } = this.state;

    this.props.updateParticipantRequest(this.handleGetID(), {
      person: {
        name: data.name,
        username: data.email,
        email: data.email,
        locale: data.locale.value
      }
    });
  };

  render() {
    const { data, errors } = this.state;
    const { update, participant } = this.props;

    return (
      <Page>
        <div className="row align-items-center">
          <div className="col-6">
            <Page.Title>Editar Participante</Page.Title>
          </div>

          <div className="col-6 text-right">
            <Button
              type="success"
              onClick={this.handleSubmit}
              disabled={update.loading || participant.loading}
            >
              {update.loading ? (
                <Loading type="btn" size="small" text="Salvando..." />
              ) : (
                "Salvar"
              )}
            </Button>

            <Link to="/admin/participants" className="btn btn-danger m-l-10">
              Cancelar
            </Link>
          </div>
        </div>

        <Panel>
          <Form
            data={data}
            errors={errors}
            onChange={this.handleChange}
            onSubmit={this.handleSubmit}
          />
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  participant: state.participants.participant,
  update: state.participants.update
});

const mapActions = dispatch =>
  bindActionCreators(ParticipantsActions, dispatch);

export default connect(mapState, mapActions)(Edit);



// WEBPACK FOOTER //
// ./src/pages/Admin/Participants/Edit/index.js